import moment from 'moment'
import {DATE_FORM_FORMAT} from "@/constants/date";

export const defaultFilters = () => ({
  filter: {
    dateFrom: moment().subtract(2, 'weeks').format(DATE_FORM_FORMAT),
    dateTo: moment().format(DATE_FORM_FORMAT),
  },
})